import { sortByKey } from "@notemeal/utils-sort";
export const getPreviewImage = (images) => {
    if (images.length === 0) {
        return null;
    }
    return sortByKey(images, "position")[0];
};
export const ASPECT_16_9 = 16 / 9;
//# sourceMappingURL=utils.js.map